export const INTEGRATION = 'INTEGRATION';
export const INTEGRATION_ALL = `${INTEGRATION}/ALL`;
export const INTEGRATION_SEARCH = `${INTEGRATION}/SEARCH`;
